import useGetSelectedMenuItem from './useGetSelectedMenuItem'

export default useGetSelectedMenuItem
